import { uniq } from 'utils/ObjectUtils';

import { createReducer } from '../../../../utils/ReduxUtils';
import * as types from '../../actionTypes';

/**
 * @typedef {Record<string, Array<string>>} UserDataSelectReducer
 */
const initialState = {};

const usersReducer = (state, { payload, meta }) => {
  const { selectId, append } = meta;
  if (selectId) {
    const data = payload.content.map(user => user.id);
    if (payload.page.number === 0 && !append) {
      return { ...state, [selectId]: data };
    }

    return { ...state, [selectId]: uniq([...(state[selectId] ?? []), ...data]) };
  }
  return state;
};

export default createReducer(initialState, {
  [types.FETCH_USERS_SUCCESS]: usersReducer,
});
